import {
    type GetAllSentNotificationsResponseType,
    type GetAllSentNotificationsRequestType
} from "./type";
import {
    request
} from "../request";

const getAllSentNotifications = async (
    params: GetAllSentNotificationsRequestType
): Promise<GetAllSentNotificationsResponseType> => {
    const serializedParams = {
        ...params
    } as Record<string, string | number | boolean | undefined>;

    const filteredParams = Object.fromEntries(
        Object.entries(serializedParams).filter(entry => entry[1] !== undefined && entry[1] !== null && entry[1] !== "")
    );
    const queryStr = Object.keys(filteredParams).length > 0 ? `?${new URLSearchParams(filteredParams as Record<string, string>).toString()}` : "";

    return await request<GetAllSentNotificationsResponseType>(
        `/notification/getAllSentNotifications${queryStr}`,
        {
            method: "GET"
        }
    );
};
export default getAllSentNotifications;
